import { post } from '../../base';

export function setMerchantReady() {
  return post('v3/merchants/ready').json<void>();
}
